import apiConfig from "../../config/apiConfig";
import apiConfigWthFormData from "../../config/apiConfigWthFormData";
import { minusDays, objToQueryString, randomString, removeKeyEmptyInObj, setBeginDay, setEndDay, showSuccessToasts } from "../../services/helpers/Helper";
import Stomp from "../../services/helpers/Stomp";
import { CONVERSATION_TYPE, END_POINT } from "../constants";
import { CONVERSATION_TYPE_ENUM } from "../reducers/conversationReducer";
import { setError } from "./errorAction";
import { hideLoading, showLoading } from "./loadingAction";

export const getAllInbox = (thread_type = CONVERSATION_TYPE_ENUM.THREAD_TYPE.ALL,
   limit = 30,
   offset = 0,
   loadMore = false
) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id,
         thread_type,
         limit,
         offset
      }

      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.GET_ALL_INBOX}?${qs}`;
      dispatch(showLoading());
      return apiConfig.get(endPoint).then((response) => {
         dispatch({
            type: loadMore ? CONVERSATION_TYPE.GET_MORE_ALL_INBOX : CONVERSATION_TYPE.GET_ALL_INBOX,
            payload: response.data
         });
         return Promise.resolve(response);
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   }

export const loadAllData = (fb_page_id) =>
   async (dispatch) => {
      const params = {
         fb_page_id
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.LOAD_ALL_DATA}?${qs}`;
      dispatch(showLoading());
      apiConfig.get(endPoint).then((response) => {
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   }

export const getInbox = (
   thread_id,
   limit = 30,
   offset = 0,
   loadMore = false
) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id,
         thread_id,
         limit,
         offset
      }

      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.GET_INBOX}?${qs}`;
      dispatch(showLoading());
      return apiConfig.get(endPoint).then((response) => {
         dispatch({
            type: loadMore ? CONVERSATION_TYPE.GET_MORE_INBOX : CONVERSATION_TYPE.GET_INBOX,
            payload: {
               data: response.data,
               threadId: thread_id
            }
         });
         return Promise.resolve(response);
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   }

export const searchInbox = () =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.SEARCH_INBOX}?${qs}`;
      dispatch(showLoading());
      apiConfig.get(endPoint).then((response) => {
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   }

export const sendMessage = (recipient, payload) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const temp_id = randomString();
      const params = {
         fb_page_id: page.social_id,
         recipient,
         payload: JSON.stringify(payload),
         temp_id: temp_id
      }
      //lưu lại message temp khi gửi, gửi xong thì update lại bằng CONVERSATION_TYPE.SEND_MESSAGE
      dispatch({
         type: CONVERSATION_TYPE.TEMP_MESSAGE,
         payload: {
            threadId: recipient,
            data: {
               inbox: [{
                  message: payload.text,
                  tempId: temp_id,
                  threadId: recipient,
                  isMessageFromPage: true,
                  createdAt: new Date(),
                  timestamp: (new Date()).getTime()
               }]
            }
         }
      });
      return apiConfigWthFormData.post(END_POINT.SEND_MESSAGE, params).then((response) => {
         dispatch({
            type: CONVERSATION_TYPE.SEND_MESSAGE,
            payload: {
               threadId: recipient,
               data: response.data
            }
         });
         return Promise.resolve(response);
      }).catch((error) => {
         dispatch(setError(error.message));
      });
   }

export const replyComment = (commentId, message) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id,
         comment_id: commentId,
         message
      }
      dispatch(showLoading());
      return apiConfigWthFormData.post(END_POINT.REPLY_COMMENT, params).then((response) => {
         return Promise.resolve(response);
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   }

export const editComment = () =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.EDIT_COMMENT}?${qs}`;
      dispatch(showLoading());
      apiConfig.post(endPoint).then((response) => {
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   }

export const hideComment = (comment_id, is_hidden) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id,
         comment_id,
         is_hidden
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.HIDE_COMMENT}?${qs}`;
      dispatch(showLoading());
      return apiConfig.post(endPoint).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   }

export const deleteComment = (comment_id) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id,
         comment_id
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.DELETE_COMMENT}?${qs}`;
      dispatch(showLoading());
      apiConfig.post(endPoint).then((response) => {
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   }

export const setStatus = (thread_id, is_read = false, is_important = false) =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = removeKeyEmptyInObj({
         fb_page_id: page.social_id,
         thread_id,
         is_read,
         is_important
      })
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.SET_STATUS}?${qs}`;
      dispatch(showLoading());
      apiConfig.post(endPoint).then((response) => {
         if (response.data.success) {
            dispatch({
               type: CONVERSATION_TYPE.SET_STATUS,
               payload: {
                  threadId: thread_id,
                  isRead: is_read,
                  isImportant: is_important
               }
            });
         }
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   }

export const setFilter = (filter) =>
   async (dispatch) => {
      dispatch({
         type: CONVERSATION_TYPE.SET_FILTER,
         payload: filter
      })
   }

export const resetFilter = () =>
   async (dispatch) => {
      dispatch({
         type: CONVERSATION_TYPE.RESET_FILTER
      })
   }

export const subscribeSocket = (fb_page_id) =>
   async (dispatch) => {
      const stomp = new Stomp();
      await stomp._connect();
      stomp.subscribe(fb_page_id);
   }

export const messageSocket = (message) =>
   async (dispatch) => {
      console.log('message', message);
      dispatch({
         type: CONVERSATION_TYPE.MESSAGE_SOCKET,
         payload: message
      })
   }

export const createDraft = (recipientId, fbPageId, recipientName) =>
   async (dispatch) => {
      const params = {
         recipientId, fbPageId, recipientName
      }
      dispatch(showLoading());
      return apiConfigWthFormData.post(END_POINT.CREATE_DRAFT, params).then((response) => {
         dispatch({
            type: CONVERSATION_TYPE.CREATE_DRAFT,
            payload: response.data
         })
         return Promise.resolve(response);
      }).catch((error) => {

      }).finally(() => {
         dispatch(hideLoading());
      })
   }

export const checkout = (cart_key, params) =>
   async (dispatch) => {
      const qs = objToQueryString({ cart_key });
      const endPoint = `${END_POINT.ORDERS_CHECKOUT}?${qs}`;

      return apiConfig.post(endPoint, params).then((response) => {
         dispatch({
            type: CONVERSATION_TYPE.CREATE_DRAFT,
            payload: response.data
         })
         return Promise.resolve(response);
      }).catch((error) => {

      }).finally(() => {

      })
   }

export const createCart = (cart_key, shipping_phone, payment_method_id, recipient_id, fb_page_id) =>
   async (dispatch) => {
      const params = {
         cart_key, shipping_phone, payment_method_id
      }
      dispatch(showLoading());
      return apiConfig.post(END_POINT.CREATE_CART, params).then((response) => {
         dispatch({
            type: CONVERSATION_TYPE.CLEAR_DRAFT
         });
         dispatch(purchaseHistory(recipient_id, fb_page_id))
         return Promise.resolve(response);
      }).catch((error) => {

      }).finally(() => {
         dispatch(hideLoading());
      })
   }

export const purchaseHistory = (recipient_id, fb_page_id) =>
   async (dispatch) => {
      const params = {
         recipient_id, fb_page_id
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.PURCHASE_HISTORY}?${qs}`;
      dispatch(showLoading());
      return apiConfig.get(endPoint).then((response) => {
         dispatch({
            type: CONVERSATION_TYPE.PURCHASE_HISTORY,
            payload: response.data
         })
         return Promise.resolve(response);
      }).catch((error) => {

      }).finally(() => {
         dispatch(hideLoading());
      })
   }

export const orderCancel = (order_code, cancelNote, cancelReasonOrder) =>
   async (dispatch) => {
      const params = {
         cancelNote,
         cancelReasonOrder,
         isRestock: true
      }
      const qs = objToQueryString({ order_code });
      const endPoint = `${END_POINT.ORDER_CANCEL}?${qs}`;
      dispatch(showLoading());
      return apiConfig.post(endPoint, params).then((response) => {
         dispatch({
            type: CONVERSATION_TYPE.ORDER_CANCEL,
            payload: order_code
         });
         return Promise.resolve(response);
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      })
   }

export const sendMessageOrder = (order_code) =>
   async (dispatch) => {
      const params = {
         order_code
      }
      dispatch(showLoading());
      return apiConfigWthFormData.post(END_POINT.SEND_MESSAGE_ORDER, params).then((response) => {
         showSuccessToasts("Gửi thành công!");
         return Promise.resolve(response);
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      })
   }

export const getListConnectedTransByShop = (shopId) =>
   async (dispatch) => {
      const qs = objToQueryString({ shopId });
      const endPoint = `${END_POINT.GET_LIST_CONNECTED_TRANS_BY_SHOP}?${qs}`;
      dispatch(showLoading());
      return apiConfig.get(endPoint).then((response) => {
         dispatch({
            type: CONVERSATION_TYPE.GET_LIST_CONNECTED_TRANS_BY_SHOP,
            payload: response.data
         });
         return Promise.resolve(response);
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      })
   }

export const getServiceGHN = (connectId, warehouseId, fromDistrict, toDistrict, dataRequest) =>
   async (dispatch) => {
      const qs = objToQueryString({ connectId, warehouseId, fromDistrict, toDistrict });
      const endPoint = `${END_POINT.GET_SERVICE_GHN}?${qs}`;
      dispatch(showLoading());
      return apiConfig.get(endPoint).then((response) => {
         dispatch({
            type: CONVERSATION_TYPE.GET_SERVICE,
            payload: {
               id: connectId,
               data: response.data
            }
         });
         response.data.forEach(item => {

            dispatch(calculateFeeGHN(connectId, warehouseId, {
               ...dataRequest,
               service_type_id: item.service_type_id
            }, response.data, item.service_id));
         });
         return Promise.resolve(response);
      }).catch((error) => {
         // dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      })
   }

export const getServiceVTPost = (connectId, warehouseId, dataRequest) =>
   async (dispatch) => {
      const qs = objToQueryString({ connectId, dataRequest: JSON.stringify(dataRequest) });
      const endPoint = `${END_POINT.GET_SERVICE_VTPOST}?${qs}`;
      dispatch(showLoading());
      return apiConfig.get(endPoint).then((response) => {
         dispatch({
            type: CONVERSATION_TYPE.GET_SERVICE,
            payload: {
               id: connectId,
               data: response.data
            }
         });
         response.data.forEach((item) => {
            dispatch(calculateFeeVTPost(connectId, warehouseId, {
               ...dataRequest,
               ORDER_SERVICE_ADD: "",
               ORDER_SERVICE: item.MA_DV_CHINH,
               NATIONAL_TYPE: 1
            }, response.data, item.service_id));
         })
         return Promise.resolve(response);
      }).catch((error) => {
         // dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      })
   }

export const calculateFeeGHN = (connectId, warehouseId, dataRequest, services, service_id) =>
   async (dispatch) => {
      const params = { connectId, warehouseId, dataRequest: JSON.stringify(dataRequest) };
      dispatch(showLoading());
      return apiConfigWthFormData.post(END_POINT.CALCULATE_FEE_GHN, params).then((response) => {
         dispatch({
            type: CONVERSATION_TYPE.GET_SERVICE,
            payload: {
               id: connectId,
               data: services.map((m) => {
                  if (m.service_id === service_id) {
                     return {
                        ...m,
                        fee: response.data
                     }
                  }
                  return m;
               })
            }
         });
         return Promise.resolve(response);
      }).catch((error) => {
         // dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      })
   }

export const calculateFeeVTPost = (connectId, warehouseId, dataRequest, services, service_id) =>
   async (dispatch) => {
      const params = {
         connectId,
         warehouseId,
         dataRequest: JSON.stringify(dataRequest)
      }

      dispatch(showLoading());
      return apiConfigWthFormData.post(END_POINT.CALCULATE_FEE_VTPOST, params).then((response) => {
         dispatch({
            type: CONVERSATION_TYPE.GET_SERVICE,
            payload: {
               id: connectId,
               data: services.map((m) => {
                  if (m.service_id === service_id) {
                     return {
                        ...m,
                        fee: response.data
                     }
                  }
                  return m;
               })
            }
         });
         return Promise.resolve(response);
      }).catch((error) => {
         // dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      })
   }

export const createOrderGHN = (warehouseId, connectId, serviceName, shippingSize, paymentType, dataRequest) =>
   async (dispatch) => {
      const params = {
         warehouseId, connectId, serviceName, shippingSize, paymentType,
         dataRequest: JSON.stringify(dataRequest)
      }

      dispatch(showLoading());
      return apiConfigWthFormData.post(END_POINT.CREATE_ORDER_GHN, params).then((response) => {
         return Promise.resolve(response);
      }).catch((error) => {
         // dispatch(setError(error.message));
         return Promise.reject(error);
      }).finally(() => {
         dispatch(hideLoading());
      })
   }

export const createOrderVTPost = (warehouseId, connectId, serviceName, shippingSize, paymentType, dataRequest) =>
   async (dispatch) => {
      const params = {
         warehouseId, connectId, serviceName, shippingSize, paymentType,
         dataRequest: JSON.stringify(dataRequest)
      }
      dispatch(showLoading());
      return apiConfigWthFormData.post(END_POINT.CREATE_ORDER_VTPOST, params).then((response) => {
         return Promise.resolve(response);
      }).catch((error) => {
         return Promise.reject(error);
      }).finally(() => {
         dispatch(hideLoading());
      })
   }